import { ITest, LabelPosition, RHookFormMaskedTextFieldWithLabel, RHookFormTextFieldWithLabel } from "@websential/cosmic";

import { FC } from "react";
import { Grid } from "@mui/material";

interface IRL3VariablesPanel extends ITest { }

export const RL3VariablesPanel: FC<IRL3VariablesPanel> = ({ testId }) => {
  return (
    <Grid
      container
      columnSpacing={6}
      rowSpacing={2}
      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
    >
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="Eligible Dividends (%)"
          id="eligibleDividends"
          testId={`${testId}-eligible-Dividends`}
        />
      </Grid>
      <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="Ordinary Dividends (%)"
          id="ordinaryDividends"
          testId={`${testId}-ordinary-Dividends`}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="Quebec Income Tax (%)"
          id="quebecIncomeTaxWithholding"
          testId={`${testId}-quebec-Income-Tax-With-holding`}
        />
      </Grid>
      <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormMaskedTextFieldWithLabel
          label="Certification No"
          id="certificationNoRl3"
          testId={`${testId}-certificationNoRl3`}
          labelPosition={LabelPosition.Top}
          placeholder={"RQ-00-00-000"}
          inputMaskPattern={"aa-00-00-000"}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormMaskedTextFieldWithLabel
          label="Authentication No"
          id="authenticationNoRl3"
          testId={`${testId}-authenticationNoRl3`}
          labelPosition={LabelPosition.Top}
          placeholder={"FS 0000000"}
          inputMaskPattern={"FS 0000000"}
        />
      </Grid>
      <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="Barcode Initial"
          id="barcodeInitialRl3"
          testId={`${testId}-barcodeInitialRl3`}
          labelPosition={LabelPosition.Top}
        // placeholder={"RQ-00-00-000"}
        // inputMaskPattern={"aa-00-00-000"}
        />
      </Grid>
    </Grid>
  );
};
